import { useMemo } from 'react';

// Constants
export const USER_COLORS = [
  '#B7C0CA',
  '#DDCA55',
  '#47BCB1',
  '#6ACDDE',
  '#A585DC',
  '#DD7AA1',
];

// Helpers
// deterministic way to get an int from a string
// used with modulo to find a random but deterministic color for a user
// Source: https://stackoverflow.com/a/52171480 (TinyStringHash, towards the bottom)
const simpleStringHash = (s: string) => {
  let result = 9;
  let index = 0;
  // eslint-disable-next-line no-restricted-syntax
  while (index < s.length) {
    // eslint-disable-next-line no-bitwise
    result = Math.imul(result ^ s.charCodeAt(index), 9 ** 9);
    index += 1;
  }
  // eslint-disable-next-line no-bitwise
  return result ^ (result >>> 9);
};

// Hooks
export const useUserColor = (id: string) => {
  return useMemo(() => {
    const authorHash = simpleStringHash(id);
    const colorIndex = Math.abs(authorHash) % USER_COLORS.length;
    return USER_COLORS[colorIndex];
  }, [id]);
};
